import { useContext, useEffect } from 'react';
import { isEmpty, isUndefined } from 'lodash';
import { valueStoreFactory } from 'services/utils/valueStoreFactory';
import { AccountContext } from '../../account-configurations';

const hasUnsavedChangesValueStore = valueStoreFactory();

export const useHasUnsavedChanges = mutatedFormFields => {
    const { isAccountTouched } = useContext(AccountContext);

    if (!isUndefined(mutatedFormFields)) {
        hasUnsavedChangesValueStore.setValue(!isEmpty(mutatedFormFields) || isAccountTouched());
    }

    useEffect(
        () => () => {
            if (!isUndefined(mutatedFormFields)) {
                hasUnsavedChangesValueStore.setValue(false);
            }
        },
        [mutatedFormFields]
    );

    return !!hasUnsavedChangesValueStore.getValue();
};
